import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import axios, { Axios } from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { NavService } from 'src/app/services/nav.service';
import { environment } from 'src/environments/environment';

interface DataItem {
  customername: number;
  naminvoicedatee: string;
  invoiceno: string;
  amount: number;
  paymentstatus: number;
}
interface DataItem1 {
  vendor: number;
  billdate: string;
  billno: string;
  amount: number;
  paymentstatus: number;
}
@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.css'],
})
export class DashboardPageComponent implements OnInit {
  orderColumn = [
    {
      title: 'CUSTOMER NAME',
    },
    {
      title: 'INVOICE DATE',
    },
    {
      title: 'INVOICE NO',
    },
    {
      title: 'AMOUNT',
    },
    {
      title: 'PAYMENT STATUS',
    },

    // {
    //   title: 'ACTION',
    // },
  ];

  productsList: DataItem[] = [
    // {
    //   customername: 'lorem ipsum',
    //   invoicedate: '01 jun 2022',
    //   invoiceno: '#1234567',
    //   amout: '₹4,000.00',
    //   paymentstatus: 'Fully Paid',
    // },
    // {
    //   customername: 'lorem ipsum',
    //   invoicedate: '01 jun 2022',
    //   invoiceno: '#1234567',
    //   amout: '₹4,000.00',
    //   paymentstatus: 'Fully Paid',
    // },
    // {
    //   customername: 'lorem ipsum',
    //   invoicedate: '01 jun 2022',
    //   invoiceno: '#1234567',
    //   amout: '₹4,000.00',
    //   paymentstatus: 'Fully Paid',
    // },
    // {
    //   customername: 'lorem ipsum',
    //   invoicedate: '01 jun 2022',
    //   invoiceno: '#1234567',
    //   amout: '₹4,000.00',
    //   paymentstatus: 'Fully Paid',
    // },
    // {
    //   customername: 'lorem ipsum',
    //   invoicedate: '01 jun 2022',
    //   invoiceno: '#1234567',
    //   amout: '₹4,000.00',
    //   paymentstatus: 'Fully Paid',
    // },
  ];

  vendororderColumn = [
    {
      title: 'VENDOR',
    },
    {
      title: 'BILL DATE',
    },
    {
      title: 'BILL NO',
    },
    {
      title: 'AMOUNT',
    },
    {
      title: 'PAYMENT STATUS',
    },

    // {
    //   title: 'ACTION',
    // },
  ];

  vendorProductsList: DataItem1[] = [];
  selectedDate = 'today';
  purChaseDetails: any = [];
  salesDetails: any = [];
  recentInvoiceDetails: any[] = [];
  recentPurchaseDetails: any[] = [];
  selectedLocation = '';

  locations = [];
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private navService: NavService
  ) {}

  fetchData(value: any, location) {
    this.spinner.show();
    axios
      .post(
        environment.url + 'dashboard/',
        { filter: value, locationFilter: location },

        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('Token'),
          },
        }
      )
      .then((response) => {
        // console.log(response.data.data);
        this.purChaseDetails = response.data.data.purchasesData;
        this.salesDetails = response.data.data.salesData;
        this.productsList = response.data.data.salesInvoices;
        // console.log(this.productsList);
        this.vendorProductsList = response.data.data.purchaseInvoices;
        this.spinner.hide();
      })
      .catch((error) => {
        console.log(error.response);
        this.spinner.hide();
      });
  }

  ngOnInit(): void {
    window.scroll(0, 0);

    this.navService.dropdownValue.subscribe((data) => {
      this.locations = data;
      // console.log(this.locations[0]?._id);
      if (this.locations[0]?._id !== undefined) {
        this.selectedLocation = 'all';
        this.fetchData('today', 'all');
      }
    });

    if (localStorage.getItem('Token') !== null) {
      this.navService.getLocationDropdown();
      this.navService.getUserDetails();
    }
  }

  dateChange(selected: any) {
    this.fetchData(selected, this.selectedLocation);
    this.selectedDate = selected;
  }

  locationChange(selectedLocation) {
    this.selectedLocation = selectedLocation;
    this.fetchData(this.selectedDate, selectedLocation);
  }

  toSales() {
    this.router.navigate(['/Sales']);
  }
  toPurchasePage() {
    this.router.navigate(['/Purchase']);
  }
}
